import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const BlueHero = ({ children, fixedBackdrop = false, className = "" }) => {
  return (
    <section className={`blue-hero ${className}`}>
      <Container>
        <Row>
          <Col xs={12} className="position-relative">
            <span className={`blue-hero-bg ${fixedBackdrop ? "" : "h-100"}`} />
            <Col
              md={8}
              className="blue-hero-content position-relative mx-auto text-center">
              {children}
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BlueHero;
